import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useEmailMarketingPermissions from "./useEmailMarketingPermissions";
import { elakayAutoText } from "../dataElakay";

// Direct-URL protection for Email Marketing pages, layered INSIDE the
// existing role guard (UserSeller): the Family-managed settings can switch a
// role off below the client-side Seller default, and only the server knows
// that. Same denial behavior as UserSeller (redirect to /your-step); nothing
// restricted renders while the check is pending. Re-evaluated on window
// focus, so a permission revoked while the page is open closes it.
const EmailMarketingAccessRoute = ({ flag = "canAccessEmailMarketing", redirectPath = "/your-step", children }) => {
  const location = useLocation();
  const { loading, error, access, refresh } = useEmailMarketingPermissions();

  if (loading) {
    return <p role="status" style={{ padding: 24, color: "#777" }}>{elakayAutoText("h_emk_tp_checking_access", "Checking access...")}</p>;
  }
  if (error && !access[flag]) {
    return (
      <div role="alert" style={{ padding: 24 }}>
        <p>{elakayAutoText("h_emk_tp_verify_failed", "Unable to verify your Email Marketing access.")}</p>
        <button type="button" className="emk-btn" onClick={refresh}>{elakayAutoText("h_emk_tp_retry", "Retry")}</button>
      </div>
    );
  }
  if (!access[flag]) return <Navigate to={redirectPath} replace state={{ from: location }} />;
  return children;
};

export default EmailMarketingAccessRoute;
